<div class="modal-header">
  <h4
    class="modal-title"
    id="modal-basic-title"
    [innerHTML]="
      article.description + ' ' + (article.caption ? article.caption : '')
    "
  ></h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
    >
  </button>
</div>
<div class="modal-body">
  <app-article-details
    #details
    [(modelId)]="modelId"
    [showDetailed]="showDetailed"
    [showInModal]="true"
    style="margin-top: 0"
    >
    <h3>{{"PREORDER"|translate}} @if (month.month) {
      {{month.month}} - {{month.year}}
      }@if (!month.month) {
      - {{ "DELIVER_WHEN_POSSIBLE" | translate }}
    }</h3>
    <table class="table">
      @for (week of weeksList; track week) {
        <tr>
          @if ((week.weekNumber >= article.stock_week && article.stock_year <= month.year) || (article.stock_year < month.year) || week.weekNumber === 0) {
            <td class="p-0">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" style="width: 180px"
                    >
                    @if (week.weekNumber) {
                      {{ "WEEK" | translate }} {{ week.weekNumber }} ({{week.date}})
                    }
                    @if (!week.weekNumber) {
                      {{ "QUANTITY" | translate }}
                    }
                  </span>
                </div>
                <input
                  type="number"
                  [min]="article.min_order_amount ? article.min_order_amount : 0"
                  max="9999"
                  class="form-control"
                  [(ngModel)]="quantities[week.weekNumber]"
                  style="max-width: 70px"
                  />
              </div>
            </td>
          }
        </tr>
      }
    </table>
    <button class="mb-2 btn btn-success btn-lg" (click)="save()">
      {{ "SAVE" | translate }}
    </button>
  </app-article-details>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-dark" (click)="modal.dismiss('Close')">
    {{ "CLOSE" | translate }}
  </button>
</div>
